const namespace = "blastPoolError";

export const DESCRIPTION = `${namespace}.description`;
export const MAX_NO_REGISTRATION = `${namespace}.maxNoRegistration`;
